import { ReactNode } from 'react';

interface ChatFileChipProps {
  icon: ReactNode;
  name: string;
  // Size or status line rendered under the name.
  secondary?: ReactNode;
  // Trailing control such as a remove button.
  action?: ReactNode;
  className?: string;
}

const ChatFileChip = ({ icon, name, secondary, action, className }: ChatFileChipProps) => (
  <div className={`chat-file-chip${className ? ` ${className}` : ''}`}>
    {icon}
    <div className="chat-file-chip-info">
      <span className="chat-file-chip-name">{name}</span>
      {secondary !== undefined && <span className="chat-file-chip-secondary">{secondary}</span>}
    </div>
    {action}
  </div>
);

export default ChatFileChip;
